import { AwsRum } from 'aws-rum-web';
import { AWS_ACCESS_KEY, AWS_RUM_ID, AWS_RUM_REGION, AWS_SECRET_KEY, VERSION } from '../constants/env';
export default class AwsRumFactory {
    static createInstance() {
        if (!AWS_RUM_ID) {
            return {
                recordPageView: () => null,
                recordError: () => null,
            };
        }
        const config = {
            sessionSampleRate: 1,
            endpoint: `https://dataplane.rum.${AWS_RUM_REGION}.amazonaws.com`,
            telemetries: [
                "errors",
                "performance",
                ['http', { recordAllRequests: true, addXRayTraceIdHeader: true }],
            ],
            allowCookies: true,
            enableXRay: false,
            disableAutoPageView: true,
        };
        const credentials = {
            accessKeyId: AWS_ACCESS_KEY,
            secretAccessKey: AWS_SECRET_KEY,
        };
        const awsRum = new AwsRum(AWS_RUM_ID, VERSION, AWS_RUM_REGION, config);
        awsRum.setAwsCredentials(credentials);
        return awsRum;
    }
}
